// extracted by mini-css-extract-plugin
export default {"cls1":"VeloProgressIndicator-Label_cls1__MApsI","cls2":"VeloProgressIndicator-Label_cls2__Kwsy3 VeloProgressIndicator-Label_cls1__MApsI"};